import { NavLink } from "react-router-dom";
import {
  ChartLineUp,
  Gauge,
  Gear,
  ClockCounterClockwise,
  Lightning,
  SignOut,
} from "@phosphor-icons/react";
import { clearToken } from "../lib/api";

const items = [
  { to: "/", label: "Dashboard", icon: Gauge, id: "nav-dashboard" },
  { to: "/scanner", label: "Scanner", icon: ChartLineUp, id: "nav-scanner" },
  { to: "/history", label: "History", icon: ClockCounterClockwise, id: "nav-history" },
  { to: "/settings", label: "Settings", icon: Gear, id: "nav-settings" },
];

export const Sidebar = () => {
  return (
    <aside className="w-56 shrink-0 border-r border-border bg-[#0a0a0a] flex flex-col">
      <div className="p-5 border-b border-border">
        <div className="flex items-center gap-2">
          <Lightning size={22} weight="fill" className="text-signal-brand" />
          <div>
            <div className="font-heading font-black tracking-tight text-sm leading-none">
              FUTURES BOT
            </div>
            <div className="font-mono text-[10px] text-muted-foreground mt-1">
              v1.0 · BINANCE
            </div>
          </div>
        </div>
      </div>
      <nav className="flex-1 p-3 space-y-1">
        {items.map(({ to, label, icon: Icon, id }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/"}
            data-testid={id}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2 text-sm rounded-sm transition-colors ${
                isActive
                  ? "bg-[#1a1a1a] text-white border-l-2 border-signal-brand"
                  : "text-muted-foreground hover:bg-[#141414] hover:text-white"
              }`
            }
          >
            <Icon size={18} weight="bold" />
            <span className="font-medium">{label}</span>
          </NavLink>
        ))}
      </nav>
      <div className="p-3 border-t border-border space-y-2">
        <button
          data-testid="logout-btn"
          onClick={() => {
            clearToken();
            window.location.href = "/login";
          }}
          className="w-full flex items-center gap-2 px-3 py-2 text-xs rounded-sm text-muted-foreground hover:bg-signal-sell/10 hover:text-signal-sell transition-colors"
        >
          <SignOut size={14} weight="bold" />
          <span className="font-mono uppercase tracking-widest">Logout</span>
        </button>
        <div className="font-mono text-[10px] text-muted-foreground">
          PAPER MODE · REAL PRICES
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
